import React, { useEffect, useState } from "react";
import axios from "axios";
import "./GenerateBill.css";
import config from "../../config";
import { useAuth } from '../../Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import GenerateBillModal from './GenerateBillModal';

const getBillingDataUrl = `${config.BASE_URL}/list-billing`;
const generatePDFBillUrl = `${config.BASE_URL}/generate-pdf-bill`;
const getVendorDataUrl = `${config.BASE_URL}/api/vendors`;
const getVehicleDataUrl = `${config.BASE_URL}/api/trucks`;

const Bill = () => {

    const Navigate = useNavigate();

    const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        vendor: '',
        truckNumber: ''
    });

    const { setTripIDState, moduleChange, setModuleChange, activeModule, setActiveModule } = useAuth();


    const [results, setResults] = useState([]);
    const [noDataMessage, setNoDataMessage] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [truckNumbers, setTruckNumbers] = useState([]);
    const [vendorQuery, setVendorQuery] = useState('');
    const [truckQuery, setTruckQuery] = useState('');
    const [showVendorDropdown, setShowVendorDropdown] = useState(false);
    const [showTruckDropdown, setShowTruckDropdown] = useState(false);
    const [selectedTransactions, setSelectedTransactions] = useState([]);
    const [showSelectAll, setShowSelectAll] = useState(false);
    const [showBillModal, setShowBillModal] = useState(false);

    useEffect(() => {
        sessionStorage.setItem('actMod', 'generate-bill');
        setActiveModule(sessionStorage.getItem('actMod'));

    }, []);

//   const formatTime = (time) =>{
//     const [timePart, ampm] = time.split(' ');
//     const [hour,minutes] = timePart.split(':');

//     let formattedTime = `${hour}:${minutes} ${ampm}`;
    
//     return formattedTime;
//   }
    const handleSearch = async (e) => {
        e.preventDefault();
        setShowTruckDropdown(false);
        setShowVendorDropdown(false);

        if ((filters.startDate && filters.endDate)) {
            if (new Date(filters.startDate) > new Date(filters.endDate)) {
                alert("End date should be greater than or equal to Start Date.");
                return;
            }
        }

        if (((filters.startDate && !filters.endDate) || (!filters.startDate && filters.endDate)) && (filters.truckNumber || filters.vendor)) {
            alert('Please select both start-date and end-date');
            return;
        }

        const validatedFilters = {
            startDate: filters.startDate || '', // Default to empty string if not provided
            endDate: filters.endDate || '',
            vendor: filters.vendor || '',
            truckNumber: filters.truckNumber || ''
        };

        // Set filters and make the API call
        setFilters(validatedFilters);

        setNoDataMessage("");
        setShowTable(false);

        try {

            const response = await axios.post(getBillingDataUrl, filters,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            console.log("response.data.resultData:", response.data.resultData);
            if (response.data.resultData && response.data.resultData.length > 0) {
                setResults(response.data.resultData);
                setShowTable(true);
            } else {
                setResults([]);
                setNoDataMessage(response.data.message);
                setShowTable(false);
            }
        } catch (error) {
            // console.error("Error fetching data:", error);
            setNoDataMessage("No data found!.");
            setShowTable(false);
        }
    };

    const fetchVendors = async () => {
        try {
            const response = await axios.get(getVendorDataUrl,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            console.log("vendors:>", response.data.vendorData);

            setVendors(response.data.vendorData);

        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    const fetchTruckNumbers = async () => {
        try {
            const response = await axios.get(getVehicleDataUrl,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            console.log("truckNumbers:>", response.data.truckData);
            setTruckNumbers(response.data.truckData);
        } catch (error) {
            if (error.response) {
                if (error.response.data.message) {
                    console.error(error.response.data.message);
                }
            }
            console.error('Error fetching truck numbers:', error);
        }
    };

    const filteredVendors = vendors?.filter((vendor) =>
        vendor?.company_name?.toLowerCase().startsWith(vendorQuery?.toLowerCase())
    ) || [];

    const filteredTrucks = truckNumbers?.filter((truck) =>
        truck.truck_no.toLowerCase().includes(truckQuery.toLowerCase())
    ) || [];

    const handleFilterChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    }

    useEffect(() => {

        fetchVendors();
        fetchTruckNumbers();

        const handleClickOutside = (event) => {
            // Close vendor dropdown if click is outside
            console.log('closest:', event.target.closest('.d1'));
            console.log('closest:', event.target.closest('.d2'));
            if (showVendorDropdown && !event.target.closest('.d1')) {
                setShowVendorDropdown(false);
            }
            // Close truck dropdown if click is outside
            if (showTruckDropdown && !event.target.closest('.d2')) {
                setShowTruckDropdown(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, [showVendorDropdown, showTruckDropdown]);

    async function fetchData() {
        console.log("Refetching data ...");
        try {
            const response = await axios.post(getBillingDataUrl, filters,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            console.log("response.data.resultData:", response.data.resultData);
            if (response.data.resultData && response.data.resultData.length > 0) {
                setResults(response.data.resultData);
                setShowTable(true);
            } else if (!response.data.resultData) {
                setResults([]);
                setNoDataMessage(response.data.message);
                setShowTable(false);
            }
        } catch (error) {
            setFilters({
                ...filters,
                startDate: "",
                endDate: "",
                vendor: "",
                truckNumber: "",
            });
            // console.error("Error fetching data:", error);
            setNoDataMessage("No more data remained to fetch.");
            setShowTable(false);
        }
    }

    const handleSingleSelect = (transactionId, isChecked) => {
        if (isChecked) {
            setSelectedTransactions(prev => [...prev, transactionId]);
            setShowSelectAll(true);
        } else {
            setSelectedTransactions(prev => prev.filter(id => id !== transactionId));
            if (selectedTransactions.length === 1) {
                setShowSelectAll(false);
            }
        }
    };

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const allIds = results.map(transaction => transaction._id);
            setSelectedTransactions(allIds);
        } else {
            setSelectedTransactions([]);
            setShowSelectAll(false);
        }
    };

    const handleGenerateBillClick = () => {
        if (selectedTransactions.length === 0) {
            alert("Please select at least one row to generate the bill.");
            return;
        }
        setShowBillModal(true);
    };

    const generatePDF = async (additionalRemarks, applyTaxes) => {
        try {
            const vendorSet = new Set();
            selectedTransactions.forEach(id => {
                const transaction = results.find(t => t._id === id);
                if (transaction?.vendor) {
                    vendorSet.add(transaction.vendor);
                }
            });

            if (vendorSet.size > 1) {
                alert("Please select transactions from only one vendor to generate the bill.");
                setShowBillModal(false);
                return;
            }

            const payload = selectedTransactions.map(id => {
                const transaction = results.find(t => t._id === id);
                return {
                    id,
                    trip_id: transaction?.trip_id,
                    vendor: transaction?.vendor,
                    transaction_status: transaction?.transaction_status,
                    destfrom: transaction?.destination_from,
                    dest: transaction?.destination_to,
                    wt: transaction?.weight,
                    actwt: transaction?.actual_weight,
                    frt: transaction?.freight,
                    rate: transaction?.rate,
                    dsl: transaction?.diesel,
                    adv: transaction?.advance,
                    toll: transaction?.toll,
                    tds: transaction?.tds,
                    billid: transaction?.billing_id,
                    remarks: additionalRemarks,
                    applyTaxes: applyTaxes,
                };
            });

            const response = await axios.post(
                generatePDFBillUrl, // Using the Bill component's URL
                payload,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    responseType: "blob"
                }
            );

            if (response.headers['content-type']?.includes('application/json')) {
                const errorData = JSON.parse(await new Response(response.data).json());
                if (errorData.errorCode === 'MULTIPLE_VENDORS') {
                    throw new Error('MULTIPLE_VENDORS_ERROR');
                }
                throw new Error(errorData.message || "Failed to generate bill");
            }

            const contentDisposition = response.headers['content-disposition'];
            let filename = "GeneratedBill.pdf"; // Fallback name

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert("Bill generated successfully.");
            setSelectedTransactions([]);
            setShowSelectAll(false);
            fetchData(); // Refresh the data
            setShowBillModal(false);
        } catch (error) {
            console.error("Error generating bill:", error);
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const errorData = JSON.parse(await error.response.data.text());
                    if (errorData.errorCode === "MULTIPLE_VENDORS") {
                        alert("Error: Please select transactions from only one vendor.");
                        return;
                    }
                    alert(`Error: ${errorData.message || "Failed to generate bill"}`);
                } catch (parseError) {
                    console.error("Failed to parse error blob:", parseError);
                    alert("Failed to generate bill. Please try again.");
                }
                return;
            }

            if (error.message === "MULTIPLE_VENDORS") {
                alert("Error: Please select transactions from only one vendor.");
            } else {
                alert(`Error: ${error.message || "Failed to generate bill"}`);
            }
        }
    };
    return (
        <div className="generate_bill">
            <div className="filter-box">
                <form onSubmit={handleSearch}>
                    <div className="filters-grid">
                        <div className="filter-item">
                            <label>Start Date</label>
                            <input
                                type="date"
                                name="startDate"
                                value={filters.startDate}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className="filter-item">
                            <label>End Date</label>
                            <input
                                type="date"
                                name="endDate"
                                value={filters.endDate}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className="filter-item d1">
                            <label>Vendor</label>
                            <input
                                type="text"
                                name="vendor"
                                placeholder="Search Vendor"
                                autocomplete="off"
                                value={vendorQuery}
                                onChange={(e) => {
                                    setVendorQuery(e.target.value)
                                    handleFilterChange(e);
                                }}
                                onClick={() => setShowVendorDropdown(true)}

                            />
                            {showVendorDropdown && (
                                <ul className="dropdown">
                                    {filteredVendors.map((vendor) => (
                                        <li
                                            key={vendor._id}
                                            onClick={() => {
                                                setFilters({ ...filters, vendor: vendor.company_name || "" });
                                                setVendorQuery(vendor.company_name);
                                                setShowVendorDropdown(false);
                                            }}
                                            style={{
                                                padding: '5px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #ddd',
                                            }}
                                        >
                                            {vendor.company_name}
                                        </li>
                                    ))}
                                    {filteredVendors.length === 0 && (
                                        <li style={{ padding: '5px' }}>No vendors found</li>
                                    )}
                                </ul>
                            )}
                        </div>

                        <div className="filter-item d2">
                            <label>Truck Number</label>
                            <input
                                type="text"
                                name="truckNumber"
                                autocomplete="off"
                                value={truckQuery}
                                onChange={(e) => {
                                    setTruckQuery(e.target.value);
                                    handleFilterChange(e);

                                }}
                                onClick={() => setShowTruckDropdown(true)}
                                placeholder="Search Truck"
                            />
                            {showTruckDropdown && (
                                <ul className="dropdown">
                                    {filteredTrucks.map((truck) => (
                                        <li
                                            key={truck._id}
                                            onClick={() => {
                                                setFilters({ ...filters, truckNumber: truck.truck_no || "" });
                                                setTruckQuery(truck.truck_no);
                                                setShowTruckDropdown(false);
                                            }}
                                            style={{
                                                padding: '5px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #ddd',
                                            }}
                                        >
                                            {truck.truck_no}
                                        </li>
                                    ))}
                                    {filteredTrucks.length === 0 && (
                                        <li style={{ padding: '5px' }}>No trucks found</li>
                                    )}
                                </ul>
                            )}
                        </div>
                    </div>
                    <button type="submit" className="search-button">
                        Search
                    </button>
                </form>
            </div>

            {/* {errorMessage && <div className="error-message">{errorMessage}</div>} */}
            {noDataMessage && <div className="no-data-message">{noDataMessage}</div>}

            {showTable && (
                <div className="bill-tabel">
                    <button
                        className="generatePDF"
                        onClick={handleGenerateBillClick}
                    >
                        Generate Bill
                    </button>
                    {showBillModal && (
                        <GenerateBillModal
                            selectedTransactions={selectedTransactions}
                            transactions={results} // Changed from transactions to results to match Bill component's state
                            onClose={() => setShowBillModal(false)}
                            onGenerate={generatePDF} // This will be our updated generatePDF function
                        />
                    )}
                    <div className="table-wrapper">
                        <table id="resultsTable">
                            <thead>
                                <tr>
                                    <th>
                                        {showSelectAll ? (
                                            <div className="select-all-container">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedTransactions.length === results.length && results.length > 0}
                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                />
                                                <span>Select All</span>
                                            </div>
                                        ) : (
                                            "Select"
                                        )}
                                    </th>
                                    {/* <th>Index</th> */}
                                    <th>Trip Id</th>
                                    <th>Username</th>
                                    <th>Profile</th>
                                    <th>Truck Number</th>
                                    <th>Date</th>
                                    {/* <th>Time</th> */}
                                    <th>Wt.</th>
                                    <th>A. Wt.</th>
                                    <th>Diff. Wt.</th>
                                    <th>Freight</th>
                                    {/* <th>Diesel (liters)</th> */}
                                    <th>Diesel</th>
                                    <th>Short</th>
                                    <th>Adv.</th>
                                    <th>Driver</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>DO</th>
                                    <th>Vendor</th>
                                    <th>Truck Type</th>
                                    <th>Transaction</th>
                                    <th>Dsl. Slp. No.</th>
                                    {/* <th>Edit</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {results.map((result) => (
                                    <tr key={result._id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="truck-checkbox"
                                                checked={selectedTransactions.includes(result._id)}
                                                onChange={(e) => handleSingleSelect(result._id, e.target.checked)}
                                                data-primarykey={result._id}
                                                data-tripid={result.trip_id}
                                                data-truckno={result.truck_no}
                                                data-dt={result.date}
                                                // data-tm={formatTime(result.time)}
                                                data-wt={result.weight}
                                                data-actual_wt={result.actual_weight}
                                                data-diff_wt={result.difference_weight}
                                                data-frgt={result.freight}
                                                // data-dsel={result.diesel}
                                                data-dsel_amt={result.diesel_amount}
                                                data-short={result.short}
                                                data-adv={result.advance}
                                                data-dri_nm={result.driver_name}
                                                data-dest_frm={result.destination_from}
                                                data-dest_to={result.destination_to}
                                                data-do_num={result.do_number}
                                                data-ven={result.vendor}
                                                data-trk_type={result.truck_type}
                                                data-trans_st={result.transaction_status}
                                                data-dsel_slpnum={result.diesel_slip_number}
                                            />
                                        </td>
                                        {/* <td>{result.id}</td> */}
                                        <td
                                            onClick={async () => {
                                                let tripId = result.trip_id;
                                                setModuleChange('/home');
                                                const response = await axios.get(`/api/trip/${tripId}`,
                                                    {
                                                        withCredentials: true,
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                        }
                                                    }
                                                );
                                                console.log('TripData', response.data.TripData)
                                                setTripIDState(response.data.TripData);

                                                Navigate(`/home/${tripId}`);
                                            }}
                                            className='trip-id'
                                        >{result.trip_id || null}</td>
                                        <td>{result.username || null}</td>
                                        <td>{result.profile || null}</td>
                                        <td>{result.truck_no}</td>
                                        <td>{result.date}</td>
                                        {/* <td>{formatTime(result.time)}</td> */}
                                        <td>{result.weight}</td>
                                        <td>{result.actual_weight}</td>
                                        <td>{result.difference_weight}</td>
                                        <td>{result.freight}</td>
                                        {/* <td>{result.diesel}</td> */}
                                        <td>{result.diesel_amount}</td>
                                        <td>{result.short}</td>
                                        <td>{result.advance}</td>
                                        <td>{result.driver_name}</td>
                                        <td>{result.destination_from}</td>
                                        <td>{result.destination_to}</td>
                                        <td>{result.do_number}</td>
                                        <td>{result.vendor}</td>
                                        <td>{result.truck_type}</td>
                                        <td>{result.transaction_status}</td>
                                        <td>{result.diesel_slip_number}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );

}

export default Bill;